<template>
    <div class="col-12 nopads">
        <top-bar :current-view="views.TEAMS_VIEW"/>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <div class="col-12 nopads mt-6">
                      <b-container class="mb-3 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                          <div class="round-btn top-right" @click.stop="addTeam">
                            <font-awesome-icon icon="plus"/>
                          </div>
                          <h3>{{ $t("page.teams") }}</h3>
                        </b-col>
                      </b-container>
                      <b-container class="pl-0 pr-0">
                        <div class="mx-auto mt-4 no-gutters">
                          <teams ref="teamlist" v-if="!editMode"
                                  @editTeam="editTeam"
                                  @alert="showAlert"
                                  class="mt-4"/>
                          <transition name="fade">
                              <team-editor
                                      v-if="editMode"
                                      :team="team"
                                      @close="showList"
                                      @closeAndUpdate="closeAndUpdate"
                                      @alert="showAlert"
                              />
                          </transition>
                        </div>
                      </b-container>
                    </div>
                </transition>
            </div>
            <footer-area />
        </div>
    </div>
</template>

<script>
    import Alert from "../components/Alert";
    import {views} from '../mixins/ViewMixin';
    import {userHelper} from "../mixins/UserMixin";
    import Teams from "../components/team/Teams";
    import {alertMixin} from "../mixins/AlertMixin";
    import TopBar from "../components/TopBar";
    import TeamEditor from "../components/team/TeamEditor";
    import FooterArea from "@/components/FooterArea";

    export default {
        name: "teams-view",
        mixins: [userHelper, alertMixin],
        components: {FooterArea, TeamEditor, TopBar, Teams, Alert},
        data() {
            return {
                views,
                editMode: false,
                team: null,
            }
        },
        methods: {
            editTeam: function (team) {
                if (this.$store.state.user.organization) {
                    this.team = team
                    this.editMode = true
                }
            },
            addTeam: function () {
                if (this.$store.state.user.organization) {
                    this.team = null
                    this.editMode = true
                }
            },
            closeAndUpdate: function () {
                this.showList()
            },

            showList() {
                this.editMode = false
            }
        }
    }
</script>

<style scoped>

</style>